export const isset = (str: string | null | undefined | []) => str && str.length && typeof str !== 'undefined'
